///////
// Navigation
//////
// Scroll magic & Gsap animate

// Init ScrollMagic
const navigation = () => {
	var mobileBreakPoint = 1000
	const navbarItems = $(
		'.navbar__navigation > ul > li:not(.menu-item-has-children)'
	)

	if ($(window).width() > mobileBreakPoint) {
		var controller = new ScrollMagic.Controller()

		var i1 = 0
		var i2 = 0
		var navHeight = $('#navbar').height()

		var scene = new ScrollMagic.Scene()
			.addTo(controller)
			.on('update', function() {
				var x1 = controller.info('scrollDirection')
				var x2 = $(window).scrollTop()
				var x3 = 110
				// When window's on the top of page
				if (x2 <= navHeight) {
					TweenLite.to(
						$('.navbar__background, .navbar__permanent-filter'),
						0.4,
						{
							autoAlpha: 0,
							display: 'none',
						}
					)
					TweenLite.to($('.navbar__logo-svg--alt'), 0.4, {
						autoAlpha: 1,
						display: 'block',
					})
				} else {
					TweenLite.to(
						$('.navbar__background, .navbar__permanent-filter'),
						0.4,
						{
							autoAlpha: 1,
							display: 'block',
						}
					)
					TweenLite.to($('.navbar__logo-svg--alt'), 0.4, {
						autoAlpha: 0,
						display: 'none',
					})
				}
				// Looking for the scroll direction
				if (x1 == 'REVERSE' && x2 >= x3 && i1 == 0) {
					// User is scrolling down
					TweenLite.fromTo(
						'#navbar',
						0.5,
						{
							position: 'fixed',
							y: '-' + navHeight * 1.5 + 'px',
						},
						{
							y: '0px',
						},
						'0'
					)
					$('.navbar__background li').each(function() {
						$(this)
							.children()
							.css('visibility', 'hidden')
					})
					i1++
					i2 = 0
				}
				if (x1 == 'FORWARD' && x2 > x3 && i2 == 0) {
					// User is scrolling to top
					TweenLite.fromTo(
						'#navbar',
						0.25,
						{
							position: 'fixed',
							y: '0px',
						},
						{
							y: '-' + navHeight * 1.5 + 'px',
						}
					)

					i1 = 0
					i2++
				}
			})

		navbarItems.each(function(i) {
			$(this).attr('data-id', i)
		})

		navbarItems.hover(function() {
			$('.navbar__gradient').toggleClass('navbar__gradient--active')

			let id = $(this).attr('data-id')

			$('.navbar__background li').each(function() {
				if ($(this).attr('data-id') === id) {
					$(this)
						.children()
						.css('visibility', 'visible')
				} else {
					$(this)
						.children()
						.css('visibility', 'hidden')
				}
			})
		})
	}
}
export { navigation }
